module.exports = __webpack_public_path__ + "img/mastercard-logo.a9890751.svg";